module.exports = __webpack_public_path__ + "static/media/35.7470318a.jpg";